import { POSTS_PER_PAGE } from 'components/Blog/constants'
import axios, { apiBaseURL } from '../axios'

const blogBaseURL = `${apiBaseURL}/blogs`

export default class BlogApi {
  static getPosts(params?: IPostsParams): Promise<IPosts> {
    return axios.get(`${blogBaseURL}?page_size=${POSTS_PER_PAGE}`, {
      params,
    })
  }

  static getPost(slug: string, token?: string): Promise<IPost> {
    const url = token ? `${blogBaseURL}/${slug}?token=${token}` : `${blogBaseURL}/${slug}`

    return axios.get(url)
  }

  static getMostRead(): Promise<IPost[]> {
    return axios.get(`${blogBaseURL}/most-read`)
  }

  static getTagsAndCategory(): Promise<ITagsAndCategories> {
    return axios.get(`${blogBaseURL}/blog-tags-and-categories`)
  }

  static getRelatedPosts(slug: string): Promise<IPost[]> {
    return axios.get(`${blogBaseURL}/${slug}/related-posts`)
  }
}
